/* eslint-disable */
export default {
  allCalls: 'Alle oproepen',
  Unknown: 'Onbekend',
  Multiple: 'Meerdere',
} as const;

// @key: @#@"allCalls"@#@ @source: @#@"All calls"@#@
// @key: @#@"Unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"Multiple"@#@ @source: @#@"Multiple"@#@
